import { useEffect } from "react";
import { notificationsConfig } from "../config/notifications.config.js";
import { useNotificationsStore } from "../stores/use-notifications-store.js";
import { NotificationsContext } from "./notifications-context.js";

const MOUNTED_GUARD = /** @type {const} */ ({ mounted: true });

/**
 * Feature Logic: inicializa fetch de pendentes + polling a cada 5 minutos.
 * Lidas são lazy — carregadas ao abrir a aba pela primeira vez no sidebar.
 *
 * @param {{ children: import("react").ReactNode }} props
 */
export function NotificationsProvider({ children }) {
  const fetchPending = useNotificationsStore((state) => state.fetchPending);

  useEffect(() => {
    fetchPending();

    const intervalId = setInterval(() => {
      fetchPending();
    }, notificationsConfig.pollingIntervalMs);

    return () => {
      clearInterval(intervalId);
    };
  }, [fetchPending]);

  return (
    <NotificationsContext.Provider value={MOUNTED_GUARD}>
      {children}
    </NotificationsContext.Provider>
  );
}
